module.exports = __webpack_public_path__ + "static/media/right-arrow.0a217ff9.svg";